import { supabase } from '@/services/supabase';
import { exchangeAppToken } from '@/services/api/varioAuth';

/**
 * Vario-Embed-Handshake.
 *
 * Erkennt einen `?appToken=` in der URL (von Vario beim iframe-Start gesetzt),
 * tauscht ihn gegen eine Supabase-Session und setzt sie via setSession.
 * Danach feuert Supabase `onAuthStateChange` (SIGNED_IN), worauf der bestehende
 * AuthProvider das Nutzerprofil laedt - der normale Auth-Flow uebernimmt also
 * unveraendert.
 *
 * @returns true, wenn ein appToken verarbeitet wurde, sonst false.
 */
export async function tryVarioHandshake(): Promise<boolean> {
  const params = new URLSearchParams(window.location.search);
  const appToken = params.get('appToken');
  if (!appToken) return false;

  const session = await exchangeAppToken(appToken);
  await supabase.auth.setSession({
    access_token: session.access_token,
    refresh_token: session.refresh_token,
  });

  // appToken aus der URL entfernen (nicht im Verlauf/in Logs behalten).
  params.delete('appToken');
  const query = params.toString();
  const clean = window.location.pathname + (query ? `?${query}` : '');
  window.history.replaceState({}, '', clean);
  return true;
}
